<div class="view-report-shell">
    <div *ngIf="resolving" class="view-report-shell-loading">
        <mat-spinner diameter="48"></mat-spinner>
    </div>

    <app-view-new-report *ngIf="!resolving && view === 'html'"></app-view-new-report>
    <app-view-report *ngIf="!resolving && view === 'legacy'"></app-view-report>
</div>
